
import React from 'react';
import { Progress } from "@/components/ui/progress";
import { Button } from "@/components/ui/button";
import { AssessmentSection, AssessmentStep } from '@/types/assessment-types';

interface AssessmentProgressProps {
  currentStep: AssessmentStep;
  isAssessmentCompleted: boolean;
  sections: AssessmentSection[];
  onNavigateSection: (sectionId: string) => void;
}

export const AssessmentProgress = ({ 
  currentStep, 
  isAssessmentCompleted, 
  sections,
  onNavigateSection 
}: AssessmentProgressProps) => {
  const getProgress = () => {
    const steps = ['start', ...sections.map(s => s.id), 'results'];
    const currentIndex = steps.indexOf(currentStep);
    return Math.round(((currentIndex) / (steps.length - 1)) * 100);
  };

  const getCurrentSection = () => {
    if (currentStep === 'start' || currentStep === 'results') return null;
    return sections.find(section => section.id === currentStep);
  };

  const getCurrentSectionNumber = () => {
    if (currentStep === 'start') return 0;
    if (currentStep === 'results') return sections.length;
    return sections.findIndex(section => section.id === currentStep) + 1;
  };

  const currentSection = getCurrentSection();
  const sectionNumber = getCurrentSectionNumber();

  return (
    <div className="mb-8">
      <Progress value={getProgress()} className="w-full" />
      <div className="mt-2 flex justify-between text-sm text-muted-foreground">
        <p>
          {currentStep === 'start' ? 'Getting Started' : 
           currentStep === 'results' ? 'Results' : 
           `Section ${sectionNumber} of ${sections.length}`}
        </p>
        {currentSection && (
          <p>{currentSection.title}</p>
        )}
      </div>
      {!isAssessmentCompleted && currentStep !== 'start' && currentStep !== 'results' && (
        <div className="mt-4 flex gap-2 justify-center">
          {sections.map((section, index) => (
            <Button
              key={section.id}
              variant={currentStep === section.id ? "default" : "outline"}
              size="sm"
              onClick={() => onNavigateSection(section.id)}
              disabled={isAssessmentCompleted}
            >
              {index + 1}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
};
